import { useLocation } from 'react-router-dom'
import { SearchForm } from '../common/SearchForm'
import SchoolRecordSetting from '../../../components/admin/schoolRecord/SchoolRecordSetting'
import SchoolRecordUserList from '../../../components/admin/schoolRecord/SchoolRecordUserList'

const AdminSchoolRecordMain = () => {
  const location = useLocation();
  const pathname = location.pathname
  const params = new URLSearchParams(location.search);
  const searchTerm = params.get('search')

  return (
    <div className="container-fluid">
      {/* Page Heading */}
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0">생활기록부 관리</h1>
      </div>

      {/* 생활기록부 노출 설정 */}
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <div className='d-flex justify-content-between align-items-center'>
            <h6 className="m-0 font-weight-bold">생활기록부 설정</h6>

            <div>
              <button form='schoolRecordSettingForm' className='btn btn-primary btn-sm'>저장</button>
            </div>
          </div>
        </div>

        <div className="card-body" style={{ height: "auto", overflow: "auto" }}>
          <div className="pt-3">
            <SchoolRecordSetting />
          </div>
        </div>

      </div>

      {/* 학생 리스트 */}
      <div className="card shadow mb-4">

        <div className="card-header py-3">
          <div className='d-flex justify-content-between align-items-center'>
            <h6 className="m-0 font-weight-bold">학생 리스트</h6>
            <SearchForm pathname={pathname} searchTerm={searchTerm} placeHolder={'학생 이름을 검색해 주세요.'} />
          </div>
        </div>

        <div className="card-body" style={{ height: "calc(100vh - 520px)", overflow: "auto" }}>
          <div className="">
            <SchoolRecordUserList searchTerm={searchTerm} />
          </div>
        </div>

      </div>
    </div>
  )
}

export default AdminSchoolRecordMain